import { t } from '../i18n'

export const ROUTES = {
  base: t('constants.routes.base'),
  simulationResult: t('constants.routes.simulationResult'),
  ownerData: t('constants.routes.ownerData'),
  additionalRiskData: t('constants.routes.additionalRiskData'),
  summaryConditions: t('constants.routes.summaryConditions'),
  formalization: t('constants.routes.formalization'),
  confirmation: t('constants.routes.confirmation'),
} as const

export const ROUTES_ENUM = {
  1: ROUTES.base,
  2: ROUTES.simulationResult,
  3: ROUTES.ownerData,
  4: ROUTES.additionalRiskData,
  5: ROUTES.summaryConditions,
  6: ROUTES.formalization,
  7: ROUTES.confirmation,
} as const
